import { 
  GET_ALL_PIPE_DETAILS, 
  GET_ALL_PIPE_DETAILS_SUCCESS, 
  GET_ALL_PIPE_DETAILS_FAILURE,
  CLEAR_ALL_PIPE_DETAILS,
  GET_LIST_MANUFACTURING_CATEGORY,
  GET_LIST_MANUFACTURING_CATEGORY_SUCCESS,
  GET_LIST_MANUFACTURING_CATEGORY_FAILURE
} from "./types";

const getAllPipeDetails = (payload) => ({
  type: GET_ALL_PIPE_DETAILS,
  ...payload
});
const getAllPipeDetailsSuccess = (payload) => ({
  type: GET_ALL_PIPE_DETAILS_SUCCESS,
  ...payload
});
const getAllPipeDetailsFailure = () => ({
  type: GET_ALL_PIPE_DETAILS_FAILURE
});

const getListManufacturingCategory = (payload = {}) => ({
  type: GET_LIST_MANUFACTURING_CATEGORY,
  ...payload
});
const getListManufacturingCategorySuccess = (payload) => ({
  type: GET_LIST_MANUFACTURING_CATEGORY_SUCCESS,
  ...payload
});
const getListManufacturingCategoryFailure = () => ({
  type: GET_LIST_MANUFACTURING_CATEGORY_FAILURE
});

const clearAllPipeDetails = () => ({
  type: CLEAR_ALL_PIPE_DETAILS
});

export {
  getAllPipeDetails, getAllPipeDetailsSuccess, getAllPipeDetailsFailure,
  getListManufacturingCategory, getListManufacturingCategorySuccess, getListManufacturingCategoryFailure,
  clearAllPipeDetails,
};

